import $ from 'jquery';

function initSlickCardGift(elem) {
    elem.slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: '<i class="material-icons">chevron_left</i>',
        nextArrow: '<i class="material-icons">chevron_right</i>',
        responsive: [
            {
              breakpoint: 980,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
    });
}

$(document).ready(function () {
    $('.idx-product_list ul').each( function() {
        initSlickCardGift($(this));
    });
});



// WEBPACK FOOTER //
// ./js/idxcartgift.js